import * as uuid from 'uuid';

export class AftercareDay {
    id;
    day;
    timeFrom;
    timeTo;
    maxEnroll;
    waitList;
    maxWaitList;
    dropIn;
    maxDropIn;
    instructorId;
    active;
    new;

    constructor(obj) {
        this.id = obj && obj.id || uuid();
        this.day = obj && obj.day || '';
        this.timeFrom = obj && obj.timeFrom || '15:00';
        this.timeTo = obj && obj.timeTo || '18:00';
        this.maxEnroll = obj && obj.maxEnroll || 10;
        this.waitList = obj && obj.waitList || false;
        this.maxWaitList = obj && obj.maxWaitList || 10;
        this.dropIn = obj && obj.dropIn || false;
        this.maxDropIn = obj && obj.maxDropIn || 10;
        this.instructorId = obj && obj.instructorId || uuid();
        this.active = obj && obj.active || true;
        this.new = obj && obj.id ? false : true;
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/aftercare-form/aftercare-day.js